// extracted by mini-css-extract-plugin
module.exports = {"fallback":"SafeProductImage_fallback__2-qgV","loaded":"SafeProductImage_loaded__3LHi9","image":"SafeProductImage_image__1hN3B"};